<template>
  <div>
    <!-- Tablet en Desktop Menu -->
    <v-toolbar large class="elevation-0" id="menublock" height="110">
      <v-toolbar-title class="menu-logo">
        <router-link to="/"><img src="../assets/logo.png" alt="avatar"></router-link>
      </v-toolbar-title>
      <v-toolbar-title class="page-title text-uppercase">{{pageHeader()}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Producten Menu Link -->
      <router-link class="menu-link" :to="{name: 'Producten'}">
        <v-flex xs12 text-xs-center>
          <v-icon>fal fa-tags</v-icon>
        </v-flex>
        <v-flex xs12>
          <span class="text-xs-center">
            Producten
          </span>
        </v-flex>
      </router-link>

      <!-- Vergelijking Pagina -->
      <router-link v-if="cartCount" class="menu-link" :to="{name: 'Vergelijken'}">
        <v-flex xs12 text-xs-center>
          <v-badge color="red" right>
            <template v-slot:badge>
              <span>{{cartCount}}</span>
            </template>
            <v-icon>
              fal fa-exchange
            </v-icon>
          </v-badge>
        </v-flex>
        <v-flex xs12>
          <span class="text-xs-center">
            Vergelijk
          </span>
        </v-flex>
      </router-link>

      <!-- Terug naar intro pagina -->
      <span @click="openRemoveDialog" class="menu-link">
        <v-flex xs12 text-xs-center>
          <v-icon>fal fa-window-close</v-icon>
        </v-flex>
        <v-flex xs12>
          <span class="text-xs-center">
            Afsluiten
          </span>
        </v-flex>
      </span>
      <!-- Einde Tablet en Desktop Menu -->

      <!-- Mobiel Icon Menu -->
      <v-toolbar-side-icon @click.stop="sideNav" class="sidebar-nav-icon mr-3">
        <v-badge color="red" right>
          <template v-slot:badge v-if="cartCount">
            <span>{{cartCount}}</span>
          </template>
          <v-icon>fas fa-bars</v-icon>
        </v-badge>
      </v-toolbar-side-icon>
    </v-toolbar>
    <!-- Einde Mobiel Icon Menu -->

    <!-- Mobiel Menu -->
    <v-navigation-drawer v-model="sideBarNav" fixed temporary right>
      <v-flex xs12 text-xs-right>
        <v-btn @click="sideNav" icon>
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-flex>

    
      <v-flex xs12 ml-4>
        <v-btn flat :to="{name: 'Producten'}" class="text-none sidebar-menu-item">
          <v-icon left>fal fa-tags</v-icon>
          <span>Producten</span>
        </v-btn>
        <v-divider class="sidebar-item-seperator ml-1" width="210"></v-divider>
      </v-flex>

      <v-flex xs12 ml-4 v-if="cartCount">
        <v-btn flat :to="{name: 'Vergelijken'}" class="text-none sidebar-menu-item">
          <v-icon left> fal fa-exchange</v-icon>
          <v-badge color="red" right>
            <template v-slot:badge>
              <span>{{cartCount}}</span>
            </template>
            <span>Vergelijk</span>
          </v-badge>
        </v-btn>
        <v-divider class="sidebar-item-seperator ml-1" width="210"></v-divider>
      </v-flex>

      <v-flex xs12 ml-4>
        <v-btn @click="openRemoveDialog" flat class="text-none sidebar-menu-item">
          <v-icon left>fal fa-window-close</v-icon>
          <span>
            Afsluiten
          </span>
        </v-btn>
      </v-flex>

    </v-navigation-drawer>
     <!-- Einde Mobiel Menu -->

    <!-- Bevestiging van verwijderen -->
    <RemoveDialog v-model="removeDialog" @confirmApprove="deleteProducts" />
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color"/>
  </div>
</template>

<script>
import GordijnenManLogo from '../assets/logo.png';
import RemoveDialog from './RemoveProductsDialog';
import SnackBar from '@/components/SnackBar'; // Meldingen venster
import Messages from '@/services/messages.service'; // Berichten
import {mapState}  from 'vuex';


export default {
  components: {
    RemoveDialog,
    SnackBar
  },
  data() {
    return {
      MenuLogo: GordijnenManLogo,
      pageTitle: '',
      sideBarNav: null,
      removeDialog: false,
      productCount: null,
      products: [],
      messageTxt: '',
      snackbar: false,
      color: 'secondary',
      loading: false,
    }
  },
  computed: {
    ...mapState('products', ['cartCount'])
  },
  methods: {
    // Pagina titel
    pageHeader() {
      this.pageTitle = this.$router.history.current.name;
      return this.pageTitle;
    },
    // Mobiel Menu
    sideNav() {
      this.sideBarNav = !this.sideBarNav;
    },
    // Opent bevestiging dialog als de session storage producten heeft
    openRemoveDialog() {
      if (this.cartCount > 0) {
        this.removeDialog = true;
      } else {
        this.$router.push({
          name: 'intro'
        })
      }
    },
    // Verwijderen
    deleteProducts() {
      this.snackbar = true;
      this.messageTxt = Messages.ProductDeletedMessage;
      setTimeout(() => {
        this.$store.dispatch('products/removeProducts')
        this.$router.push({
          name: 'intro'
        })
      }, 2000)
    },
    // Lengte van producten

  }
}
</script>


<style scoped>
  #menublock {
    background-color: #fff;
    border-bottom: 1px solid #b4b4b4;
  }

  .menu-link {
    margin-right: 2em;
    text-decoration: none;
    color: #000;
  }

  .page-title {
    color: #006fb3;
  }


  .menu-logo {
    margin-left: 3em;
  }

  #header {
    margin-right: 13em !important;
  }

.sidebar-nav-icon {
  display:  none;
}
  @media screen and (max-width: 1440px) {
    .menu-logo {
      margin-left: 6em;
    }

    #close {
      margin-right: 10em;
    }
  }

  @media screen and (max-width: 1024px) {
    #close {
      margin-right: 5em;
    }

    .menu-logo {
      margin-left: 3em;
    }
  }

  @media screen and (max-width: 425px) {
    .menu-logo {
      margin-left: 0;
    }

    .menu-link {
      display: none;
    }

    .sidebar-nav-icon {
  display:  unset;
}

    .page-title {
      margin-left: 15px;
      font-size: 18px;
    }

    #close {
      margin-right: 0;
    }

    .menu-link {
      margin-right: 1.5em;
    }
  }

</style>